<template>
  <div>
    <div
      class="modal fade"
      id="cancelModal"
      tabindex="-1"
      aria-labelledby="policies-modal"
      aria-hidden="true"
    >
      <loader />
      <div class="modal-dialog modal-xl">
        <div class="modal-content rounded-0">
          <div class="modal-header rounded-0" style="background-color:#169a5a;">
            <h5 class="modal-title modaltitle" id="policies-modal">
              {{ $t('cancel.c1') }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b-row>
              <b-col md="12">
                <p>{{ $t('cancel.c2') }}</p>
                <!-- <div class="borderdiv">
                                <select v-model="motivo" class="input-sucursal">
                                  <option 
                                          :value="motivo" 
                                          :key="motivo.id" 
                                          v-for="motivo in motivos">
                                          {{ motivo.motivo }}
                                  </option>
                                </select>
                            </div> -->
                <!--  -->
                <div class="borderdiv">
                  <b-form-select v-model="selected" class="mb-3 input-sucursal">
                    <b-form-select-option :value="null" disabled>{{
                      $t('cancel.c6')
                    }}</b-form-select-option>
                    <b-form-select-option
                      :key="motivo.id"
                      v-for="motivo in motivosCancelar"
                      :value="motivo"
                    >
                      <div v-if="$i18n.locale === 'en'">
                        <span v-if="motivo.id === 1" class="titledetails"
                          >No need rent</span
                        >
                        <span v-else-if="motivo.id === 2" class="titledetails"
                          >Travel canceled</span
                        >
                        <span v-else-if="motivo.id === 3" class="titledetails"
                          >for health reasons</span
                        >
                        <span v-else-if="motivo.id === 4" class="titledetails"
                          >Less than 24 years</span
                        >
                        <span v-else-if="motivo.id === 5" class="titledetails"
                          >No credit card</span
                        >
                        <span v-else-if="motivo.id === 6" class="titledetails"
                          >Low balance in credit card</span
                        >
                        <span v-else-if="motivo.id === 7" class="titledetails"
                          >Wheather problems</span
                        >
                        <span v-else-if="motivo.id === 8" class="titledetails"
                          >Another better offer</span
                        >
                        <span v-else-if="motivo.id === 9" class="titledetails"
                          >Duplicity</span
                        >
                        <span v-else-if="motivo.id === 10" class="titledetails"
                          >No equipment or accesories available</span
                        >
                        <span v-else-if="motivo.id === 11" class="titledetails"
                          >Unavailable requested model</span
                        >
                        <span v-else-if="motivo.id === 12" class="titledetails"
                          >Other</span
                        >
                      </div>
                      <span v-else class="titledetails">{{
                        motivo.motivo
                      }}</span>
                    </b-form-select-option>
                  </b-form-select>
                  <!-- {{selected}} -->
                </div>
                <!-- <div class="mt-2">text: <strong>{{ motivos }}</strong></div> -->
                <!--  -->
                <div class="form-group mt-3" v-if="selected.id == 12">
                  <label for="otromotivo">{{ $t('cancel.c3') }}</label>
                  <textarea
                    class="form-control"
                    id="otromotivo"
                    rows="3"
                    v-model="otro_motivo"
                  ></textarea>
                </div>
                <br />
                <!-- <button class="btn btn-success float-right" type="button" data-dismiss="modal" aria-label="Close" style="border-radius:0px;">{{$t('cancel.c4')}}</button> -->
                <button
                  class="btn btn-success float-right mr-2"
                  style="border-radius:0px;"
                  @click="cancel_gtm(), anularReserva()"
                >
                  {{ $t('cancel.c5') }}
                </button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <reservaCancelada :id="id"></reservaCancelada>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import loader from '@/components/loader.vue'
import reservaCancelada from '@/components/modalReservaCancelada'
import { useGtm } from '@gtm-support/vue2-gtm'

export default {
  created() {
    this.motivosCancelarReserva()
  },
  components: {
    loader,
    reservaCancelada
  },
  data() {
    return {
      motivo: {
        id: 1,
        motivo: 'No necesita arrendar'
      },
      selected: {
        id: 1,
        motivo: 'No necesita arrendar'
      },
      otro_motivo: null,
      reservaAnulada: false
    }
  },
  props: ['id'],
  computed: {
    ...mapState('reservav2', ['motivosCancelar'])
  },
  methods: {
    //...mapActions('reserva', ['motivosCancelarReserva', 'cancelarReserva']),
    ...mapActions('reservav2', ['motivosCancelarReserva', 'cancelarReserva']),
    async anularReserva() {
      const resp = await this.cancelarReserva({
        id: this.id,
        id_motivo: this.selected.id,
        otro_motivo: this.otro_motivo
      })
      if (resp == 'reserva anulada') {
        $('#cancelada').modal({
          backdrop: 'static',
          keyboard: false
        })
        $('#cancelModal').modal('hide')
      }
    },
    cancel_gtm() {
      let gtm = useGtm()

      gtm.trackEvent({
        event: 'ev_cancellation', // Static data
        category: 'cancel_reservation', // Static data
        action: 'cancellation', // Static data -> Action
        confirmation_number: this.id, // CD10 Dynamic data
        reason_cancellation: this.selected.motivo // CD17 Dynamic data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.borderdiv {
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}
.modaltitle {
  font-family: 'DIN 2014-Regular';
  font-size: 18px;
  color: #fff;
}
.input-sucursal {
  border: none;
  height: 60px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 20px;
  width: 99%;
  background: url('/img/flecha.png') no-repeat right/1.4%;
  background-color: rgb(255, 255, 255);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
